export const timeFormat = navigator.language.toLocaleLowerCase().includes("us")
  ? "h:mm aa"
  : "HH:mm";

export const dateFormat = navigator.language.toLocaleLowerCase().includes("us")
  ? "MM/dd/yyyy"
  : "dd/MM/yyyy";
